
<b-row class="info-desactivation d-flex bg-white align-items-center text-center h-100 py-1 mx-0">
  <b-col
    v-if="content.texteDesactivation"
    class="de-retour-bientot graphik_semibold align-self-center"
    v-html="content.texteDesactivation"
  >
  </b-col>
  <b-col v-else class="align-self-center">
    <p class="jeu-non-disponible graphik_bold p-0">
      {{ $t('jeuNonDisponible') }}
    </p>
    <p class="de-retour-bientot graphik_semibold p-0">
      {{ $t('deRetourBientot') }}
    </p>
  </b-col>
</b-row>
